import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { withStyles, CircularProgress, Button, Tooltip } from '@material-ui/core';
import { KeyboardArrowDown as DownIcon, Refresh as RefreshIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEMessageSender } from 'data/components';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { TicketHistoryMessage, TicketHistoryEvent } from '.';

class TicketHistory extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        addMessage: PropTypes.func,
        getMoreData: PropTypes.func.isRequired,
        deleteMessage: PropTypes.func,
        data: PropTypes.object.isRequired,
        nbRemainingLines: PropTypes.number.isRequired,
    };

    static defaultProps = {
        deleteMessage: null,
        addMessage: null,
    };
    constructor(props) {
        super(props);
        this.state = {
            moreTicketLoading: false,
            refreshLoading: false,
            deleteLoading: null,
        };
    }
    loadMoreTicketHistory = () => {
        const { getMoreData, data } = this.props;
        this.setState({
            moreTicketLoading: true,
        });
        return getMoreData(Object.keys(data).length, 10).finally(() => {
            this.setState({
                moreTicketLoading: false,
            });
        });
    };

    deleteFheTicketHistory = id => {
        const { deleteMessage, history } = this.props;
        this.setState({
            deleteLoading: parseInt(id),
        });
        Toastr.confirm(
            Translator.translate(`generic.ticketing.actions.confirmationRemoveTicket`),
            Translator.translate(`generic.ticketing.actions.confirmationRemoveTicketTitle`),
            {
                onYes: () => {
                    return deleteMessage(id).finally(() => {
                        this.setState({ deleteLoading: null });
                    });
                },
                onNo: () => {
                    this.setState({ deleteLoading: null });
                },
            },
        );
    };

    refreshTicketHistory = () => {
        const { getMoreData, data } = this.props;
        this.setState({
            refreshLoading: true,
        });
        return getMoreData(0, Object.keys(data).length).finally(() => {
            this.setState({
                refreshLoading: false,
            });
        });
    };

    renderAddTicketHistory = () => {
        const { addMessage } = this.props;
        return <FHEMessageSender sendMessageFunc={addMessage} />;
    };
    renderMoreHistory = () => {
        const { classes, history } = this.props;
        const { moreTicketLoading } = this.state;

        return (
            <Tooltip title={Translator.translate(`generic.ticketing.actions.loadMoreTicketsHistory`)} placement="top">
                <div className={classes.loadMoreTicketHistory}>
                    <Button onClick={this.loadMoreTicketHistory} className={classes.colorGrey400}>
                        {moreTicketLoading ? <CircularProgress size={25} /> : <DownIcon />}
                    </Button>
                </div>
            </Tooltip>
        );
    };

    renderRefreshHistory = () => {
        const { refreshLoading } = this.state;
        const { classes, history } = this.props;

        return (
            <Tooltip title={Translator.translate(`generic.ticketing.actions.refreshTicketsHistoryList`)} placement="top">
                <div className={classes.refreshTicketHistoryList}>
                    <Button onClick={this.refreshTicketHistory} className={classes.colorGrey400}>
                        {refreshLoading ? <CircularProgress size={25} /> : <RefreshIcon />}
                    </Button>
                </div>
            </Tooltip>
        );
    };
    renderTicketHistoryList = () => {
        const { deleteLoading } = this.state;
        const { profile, classes, data, deleteMessage, history } = this.props;

        const rightDeleteTicketHistory =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketHistoryDelete');

        let result = [];
        let lastDate;
        const today = moment().format('DD/MM/YYYY');
        const yesterday = moment()
            .subtract(1, 'days')
            .format('DD/MM/YYYY');

        if (Object.keys(data).length > 0) {
            Object.keys(data)
                .sort((a, b) => {
                    const fieldA = moment(data[a].createdAt, 'DD/MM/YYYY hh:mm:ss');
                    const fieldB = moment(data[b].createdAt, 'DD/MM/YYYY hh:mm:ss');
                    return fieldA.isAfter(fieldB) ? -1 : 1;
                })
                .map((id, key) => {
                    let ticketHistory = data[id];

                    let date;
                    const dateTicket = moment(ticketHistory.createdAt, 'DD/MM/YYYY').format('DD/MM/YYYY');
                    if (dateTicket === today) {
                        date = Translator.translate('general.today');
                    } else if (dateTicket === yesterday) {
                        date = Translator.translate('general.yesterday');
                    } else {
                        date = moment(ticketHistory.createdAt, 'DD/MM/YYYY').format('dddd DD MMMM YYYY');
                    }

                    if (date !== lastDate) {
                        lastDate = date;
                        result.push(
                            <div key={`${key}date`}>
                                <div className={classes.date}>- {date} -</div>
                            </div>,
                        );
                    }

                    if (ticketHistory.type === 'comment') {
                        result.push(
                            <div key={key}>
                                <TicketHistoryMessage
                                    ticketHistory={ticketHistory}
                                    ticketHistoryId={parseInt(id)}
                                    deleteFheTicketHistory={typeof deleteMessage === 'function' ? this.deleteFheTicketHistory : null}
                                    deleteLoading={deleteLoading}
                                    rightDeleteTicketHistory={rightDeleteTicketHistory}
                                />
                            </div>,
                        );
                    } else {
                        result.push(
                            <div key={key}>
                                <TicketHistoryEvent ticketHistory={ticketHistory} />
                            </div>,
                        );
                    }
                });
        }

        return result;
    };
    render() {
        const { addMessage, nbRemainingLines, classes } = this.props;
        return (
            <div style={{ width: '100%', height: '100%' }}>
                {typeof addMessage === 'function' ? this.renderAddTicketHistory() : null}
                {this.renderRefreshHistory()}
                <div className={classes.noteContainer}>
                    {this.renderTicketHistoryList()}
                    {nbRemainingLines > 0 && this.renderMoreHistory()}
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
    loadMoreTicketHistory: {
        marginTop: 30,
        width: '100%',
        textAlign: 'center',
    },
    refreshTicketHistoryList: {
        width: '100%',
        marginBottom: 20,
        textAlign: 'center',
    },
    colorGrey400: {
        color: theme.palette.colors.grey400,
    },
    date: {
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '20px',
    },
    noteContainer: {
        width: '100%',
        height: '75%',
        paddingRight: 10,
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
});

export default withRouter(renderEnvComponent('components/TicketHistory', withStyles(styles, { withTheme: true })(TicketHistory)));



// WEBPACK FOOTER //
// ./environments/genericEnv/components/TicketHistory.js